import React, { useContext } from 'react';
import { PageDataContext } from './types';

const PagePropsContext = React.createContext<PageDataContext>(null);

export const usePagePropsContext = (): unknown => useContext(PagePropsContext);

export default PagePropsContext;
